$(document).foundation();
$(document).ready( function () {	
	

	patternlib();


	// Show the language picker on first visit
	if ( $('#language-selector-wrapper').length > 0 ) {
		$('body').addClass('language-popup-open');
		$.fancybox({
			type: 'inline',
			content: $('#language-selector-wrapper').html(),
			closeBtn: false,
			modal: true,
			padding: 0,
			wrapCSS: 'language-selector-popup',
			afterClose: function () {
				$('body').removeClass('language-popup-open');
			}
		});
	}
 



	// Slidderz
	if ( $('.full-page-slider').length > 0 ) {

	

		if ( $('body').hasClass('homepage') ) {
			$('.full-page-slider').first().append('<div class="full-page-slide-logo"></div>');

			setTimeout(function () {
				$('.full-page-slide-logo').fadeOut(1000);
			}, 3000);
		}

		var pagination = false;
		var autoplay = true;
		if ( $('.full-page-slider-inner').hasClass('dots') ) {
			pagination = true;
			autoplay = false;
		}

		$('.full-page-slider-inner').reformSlider({
			speed: 4000,
			animationSpeed: 1000,
			arrows: true,
			pagination: pagination,
			autoplay: autoplay
		});

		
		// Hide the video from non-autoplaying devices
		if ( $('.full-page-slide-video').length > 0 ) {
			isAutoplaySupported(function(supported) {
				if ( (!supported) ) {
					$('.full-page-slide-video iframe').hide();
				}
			});
		}


		if ( $('.full-page-slide-video').length > 0 ) {
			// This slider has a video in it...

			scaleVideo();
			$(window).on('resize', scaleVideo);

			function scaleVideo() {
				var viewportWidth = $(window).innerWidth();
				var viewportHeight = $(window).innerHeight();
				var videoWidth = $('.full-page-slide-video iframe').attr('width');
				var videoHeight = $('.full-page-slide-video iframe').attr('height');

				// Aspect ratio = height / width
				var viewportRatio = viewportHeight / viewportWidth;
				var videoRatio = videoHeight / videoWidth;

				//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);

				if (viewportRatio > videoRatio) {
					// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
					//console.log('crop left and right');
					var newWidth = (videoWidth / videoHeight) * viewportHeight
					$('.full-page-slide-video iframe').css('height', viewportHeight);
					$('.full-page-slide-video iframe').css('width', newWidth);
					$('.full-page-slide-video iframe').css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
				} else if (viewportRatio < videoRatio) {
					// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
					//console.log('crop top and bottom');
					var newHeight = (videoHeight / videoWidth) * viewportWidth;
					$('.full-page-slide-video iframe').css('width', viewportWidth);
					$('.full-page-slide-video iframe').css('height', newHeight);
					$('.full-page-slide-video iframe').css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
				} else {
					// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
					//console.log('no crop');
					$('.full-page-slide-video iframe').css('height', viewportHeight);
					$('.full-page-slide-video iframe').css('width', viewportWidth);
				}
			}

		}

	}


	$('.full-page-slider-scroll button').on('click', function () {
		$('html, body').animate({
			scrollTop: $('.full-page-slider').outerHeight()
		}, 750);
	});


	$('.tall-slider').slick({
		speed: 4000,
		animationSpeed: 300,
		autoplay: true,
		arrows: true,
		fade: true
	});





	// Add a dropshadow to the header once the user begins to scroll
	fixHeader();
	$(document).on('scroll', _.throttle(fixHeader, 100));

	function fixHeader() {
		if ($(window).scrollTop() >= 2) {
			$('body').addClass('fix-header');
		} else {
			$('body').removeClass('fix-header');
		}
	}




	// Burger menu triggers
	$('.burger-primary a').on('click', function () {
		if ( $(this).next('ul').length > 0 ) {
			// Slide over to show the sub pages but only if there are any to show
			$('.burger-primary').addClass('slide-over');
			$(this).parent().addClass('show-children');
		}
	});

	$('.close-button, .burger-level-up button').on('click', function () {
		$('.burger-primary').removeClass('slide-over');
		$('.show-children').removeClass('show-children');
	});




	// Accommodation filters
	$('.toggle-filters').on('click', function () {
		$('.filters').toggleClass('show-filters');
	});

	$('.filter-list button').on('click', function () {
		$(this).toggleClass('on');
		filterAccommodation();
	});

	$('.clear-filters').on('click', function () {
		$('.filter-list button.on').removeClass('on');
		filterAccommodation();
	});

	function filterAccommodation() {
		var filterSelector = '';
		$('.filter-list button').each( function() {
			if ($(this).hasClass('on')) {
				filterSelector += '.filter-' + $(this).data('filter') + ',';
			}
		});

		$('.carousel-inner').slick('slickUnfilter', -1);

		$('.carousel').prev('.page-heading').show();

		if (filterSelector != '') {
			filterSelector = filterSelector.slice(0, -1); // trim the trailing comma
			$('.carousel-inner').slick('slickFilter', filterSelector);
		}

		var itemWidth = $('.carousel-item').first().outerWidth();

		$('.slick-track').each( function() {

			// hide the heading for any carousel with no items
			if ($(this).children().length > 0) {
				$( $(this).parents('.carousel').prev() ).add( $(this).parents('.carousel').prev().prev() ).show();
				$(this).parents('.carousel').show();
			} else {
				$( $(this).parents('.carousel').prev() ).add( $(this).parents('.carousel').prev().prev() ).hide();
				$(this).parents('.carousel').hide();
			}

			// Center it if there is only 1 element left
			if ($(this).children().length === 1) {
				$(this).parent().parent().slick('slickSetOption', 'slidesToShow', 1, true);

				$(this).find('.carousel-item').css({
					float: 'none',
					margin: '0 auto',
					width: itemWidth + 'px'
				});
			} else {
				$(this).find('.carousel-item').css({
					float: 'left',
					margin: '0'
				});
				$(this).parent().parent().slick('slickSetOption', 'slidesToShow', 2, true);
			}

		});
	}




	// Merry-go-rounds and other fun rides
	$('.carousel-inner').slick({
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	$('.carousel-inner').on('init reInit setPosition', function(slick) {
		$('.carousel-inner .slick-arrow').css('height', $('.carousel img').first().outerHeight() );
	});

	$('.large-promo-carousel').slick({
		arrows: true
	});
	$('.large-promo-carousel').on('init reInit setPosition', function(slick) {
		$('.large-promo-carousel .slick-arrow').css('height', $('.large-promo-carousel img').first().outerHeight() );
	});





	// Accordions
	$('.all-accommodation, .offers-accordion').accordiom({
		showFirstItem: false
	});

	$('.downloads-accordion').accordiom();

	$('.comparison-table-accordion').accordiom();



	// Gallery triggers
	$('a[href="#open-gallery"]').on('click', function () {
		$('.accommodation-gallery').show();
		$('html, body').animate({
			scrollTop: 0
		}, 0);
		return false;
	});

	$('.accommodation-gallery .close-button').on('click', function () {
		$('.accommodation-gallery').hide();
	});

	$('.gallery-grid a').fancybox({
		type: 'ajax',
		width: '100%',
		height: '100%',
		margin: 0,
		padding: 0,
		autoSize: false,
		mouseWheel: false,
		arrows: false,
		nextEffect: 'fade',
		prevEffect: 'fade',
		wrapCSS: 'gallery-popup'
	});

	var count = 0;
	$('.gallery-grid-item, .gallery-grid__playlist-heading').each( function () {
		$(this).data('number', count);
		count++;
	});

	function sortDefault(selector) {
		$(selector).children('.gallery-grid-item, .gallery-grid__playlist-heading').sort(function(a, b) {
			var A = $(a).data('number');
			var B = $(b).data('number');
			return (A < B) ? -1 : (A > B) ? 1 : 0;
		}).appendTo(selector);
	}

	function sortAZ(selector) {
		$(selector).children('.gallery-grid-item').sort(function(a, b) {
			var A = $(a).find('.gallery-grid-item__caption').text().toUpperCase();
			var B = $(b).find('.gallery-grid-item__caption').text().toUpperCase();
			return (A < B) ? -1 : (A > B) ? 1 : 0;
		}).appendTo(selector);
	}

	function sortZA(selector) {
		$(selector).children('.gallery-grid-item').sort(function(a, b) {
			var A = $(a).find('.gallery-grid-item__caption').text().toUpperCase();
			var B = $(b).find('.gallery-grid-item__caption').text().toUpperCase();
			return (A > B) ? -1 : (A < B) ? 1 : 0;
		}).appendTo(selector);
	}

	$('#images-dropdown').on('change', function () {
		if ($(this).val()=='A-Z') {
			sortAZ('#images-tab .gallery-grid');
		} else if ($(this).val()=='Z-A') {
			sortZA('#images-tab .gallery-grid');
		} else {
			sortDefault('#images-tab .gallery-grid');
		}

		Foundation.reInit('equalizer');
	})

	function sortOld(selector) {
		$(selector).children('.gallery-grid-item').sort(function(a, b) {
			var A = new Date($(a).find('.gallery-grid-item__date').data('date'));
			var B = new Date($(b).find('.gallery-grid-item__date').data('date'));
			return (A < B) ? -1 : (A > B) ? 1 : 0;
		}).appendTo(selector);
	}

	function sortNew(selector) {
		$(selector).children('.gallery-grid-item').sort(function(a, b) {
			var A = new Date($(a).find('.gallery-grid-item__date').data('date'));
			var B = new Date($(b).find('.gallery-grid-item__date').data('date'));
			return (A > B) ? -1 : (A < B) ? 1 : 0;
		}).appendTo(selector);
	}

	$('#video-dropdown').on('change', function () {
		if ($(this).val()=='new') {
			$('.gallery-grid__playlist-heading').hide();
			sortNew('#video-tab .gallery-grid');
		} else if ($(this).val()=='old') {
			$('.gallery-grid__playlist-heading').hide();
			sortOld('#video-tab .gallery-grid');
		} else {
			$('.gallery-grid__playlist-heading').show();
			sortDefault('#video-tab .gallery-grid');
		}
		Foundation.reInit('equalizer');
	})


	/*** Filterable Gallery ***/
	var $_filterButtons = $('.gallery-filters button');
	var $_filterSelectGallery = $('.gallery-filters-mobile #filter-select')
	var $_filterSelectPlaylist = $('.playlist-filters-mobile #playlist-select')
	var $_filterItems = $('#images-tab .gallery-grid-item');

	$('.gallery-filters button').on('click', function () {

		if ( $(this).hasClass('on') ) return; // already selected so do nothing

		$('.gallery-filters button').removeClass('on');
		$(this).addClass('on');

		$('.gallery-grid-item.column.center-this').removeClass('center-this');

		if ( $(this).hasClass('all') ) {
			$('#images-tab .gallery-grid').removeClass('filtered');
			$_filterItems.fadeIn().children('a').attr('data-fancybox-group', 'gallery');
			if (history.pushState) {
				history.pushState('', document.title, window.location.pathname + window.location.search);
			}
			else {
				location.hash = '#';
			}
			return;
		} else {
			$('#images-tab .gallery-grid').addClass('filtered');
		}

		// Set the window hash URL to the current category
		if (history.pushState) {
			history.pushState(null, null, '#' + $(this).data('filter'));
		}
		else {
			location.hash = '#' + $(this).data('filter');
		}

		var currentCats = '';

		// Loop through the "on" buttons and build a class selector string of the active
		$_filterButtons.each( function () {
			if ( $(this).hasClass('on') ) {
				currentCats += '.' + $(this).data('filter') + ', ';
			}
		});

		
	

		currentCats = currentCats.substr(0, currentCats.length - 2); // Remove the last comma and space from the string, otherwise jQuery borks
		
		// No categories selected so show them all
		/*if ( currentCats == '' ) {
			$_filterItems.fadeIn();
			return;
		}*/

		// Hide or show the elements that match the class
		$_filterItems.each( function () {
			if ( $(this).is(currentCats) ) {
				$(this).fadeIn().children('a').attr('data-fancybox-group', 'gallery');
			} else {
				$(this).fadeOut().children('a').removeData('fancybox-group').removeAttr('data-fancybox-group');
			}
		});

		setTimeout(centerGalleryWidows, 500);

	});

	$_filterSelectGallery.on('change', function () {
		currentCats = $(this).val();
		console.log($(this).val())

		if ( currentCats == '' ) {
			$_filterItems.fadeIn();
			return;
		}
		$_filterItems.each( function () {
			if ( $(this).hasClass(currentCats) ) {
			
				$(this).fadeIn().children('a').attr('data-fancybox-group', 'gallery');
			} else {
				
				$(this).fadeOut().children('a').removeData('fancybox-group').removeAttr('data-fancybox-group');
			}
		});
	})

	$_filterSelectPlaylist.on('change', function () {
		var target = $(this).val()

		if ( target == '' ) {
			$('.gallery-grid-item-video').fadeIn();
			return;
		}

		$('.gallery-grid-item-video').each(function () {
			if ( $(this).data('playlist') === target ) {
				$(this).fadeIn();
			} else {
				$(this).fadeOut();
			}
		});


	})


	
	
	
	
	
	/*** Filter the gallery video playlists ***/
	$('.gallery-playlist-filters button').on('click', function () {
		$filterButton = $(this);
		
		if ( $filterButton.hasClass('on') ) return;
		
		$('.gallery-playlist-filters button.on').removeClass('on');
		$filterButton.addClass('on');
		
		if ( $filterButton.hasClass('all') ) {
			// Show all playlists
			$('.gallery-grid__playlist-heading, .gallery-grid-item-video').fadeIn();
		} else {
			$('.gallery-grid__playlist-heading').fadeOut();
			
			// Only show the playlists which match
			$('.gallery-grid-item-video').each(function () {
				if ( $(this).data('playlist') === $filterButton.text() ) {
					$(this).fadeIn();
				} else {
					$(this).fadeOut();
				}
			});
		}
	});




	// Allow pre-filtering with hash URLs
	if ( window.location.hash != '' ) {
		var hashCat = window.location.hash.replace('#', '');
		$('.gallery-filters button[data-filter="' + hashCat + '"]').trigger('click');
	}



	// Calculate the remainder gallery items that don't fit on the row and center them
	function centerGalleryWidows() {

		var numWidows = 0;

		if ( $(window).innerWidth() > 1024 ) { // 3 column large layout
			numWidows = $('.gallery-grid-item:visible').length % 3;
		} else if ( $(window).innerWidth() > 1024 ) { // 2 column tablet layout
			numWidows = $('.gallery-grid-item:visible').length % 2;
		} else {
			return; // must be mobile so do nothing
		}

		if ( numWidows > 0 ) {
			$('.gallery-grid-item:visible').slice( numWidows * -1 ).addClass('center-this');
		}

	}



	// Center widows on the grids
	$('.grid-2-column').each( function() {
		if ( $(this).children().length === 1 ) {
			$(this).children('.medium-6').addClass('medium-centered');
		}
	});


	function getBlogPosts(url) {
		$.ajax({ type: 'GET',
			url: url,
			success : function(blogPosts) {
				$('.blog-grid').append(blogPosts);
			}
		});
	}

	// Blog pages
	$(document.body).on('click', '.load-more', function () {
		$(this).animate({
			'opacity': 0,
			'marginTop': 0,
			'marginBottom': 0,
			'height': 0
		});
		getBlogPosts($(this).data('blog-posts'));
	});

	if ($('.blog-grid').length > 0) {
		getBlogPosts("/blogPosts?blogPageId=" + $('.blog-grid').data('blog-page-id') + "&rowStart=0&rowCount=2");
	}

	// Scale the blog post inline images to expand the wrapper
	if ($('.blog-post').length > 0) {
		setBlogImageWidths();
		$(window).on('resize', _.throttle(setBlogImageWidths, 100));
		function setBlogImageWidths() {
			var blogWidth = $('.blog-post .columns').first().outerWidth();
			$('.blog-post p img').each( function() {
				$('.blog-post p img').css('width', blogWidth + 320);
			});
		}
	}





	// Submit the newsletter form
	$('.newsletter-cta form').validate();

	// change options colour on select
	function setOptionsColour (selectors) {
		selectors.on('change', function () {
			if ($(this).val() === '') {
				$(this).css('color', 'grey')
				return
			}
			$(this).css('color', '#333')
		})
	}
	setOptionsColour($('.date-of-birth-wrapper select' ))


	// Deep link to an offer accordion item
	if ( ($('.offers-accordion').length > 0) && (window.location.hash != '') ) {
		$('.offers-accordion .accordionButton h2').each( function () {

			// Replace the odd characters
			var offerTitle = $(this).text();
			offerTitle = offerTitle.replace(' ', '-');
			offerTitle = offerTitle.replace("'", '');
			offerTitle = offerTitle.replace('&', '');
			offerTitle = offerTitle.toLowerCase();

			if ( '#' + offerTitle == window.location.hash ) {
				// scroll to it
				$('html, body').animate({
			        scrollTop: $(this).offset().top
			    }, 1000);

			    // and open it
			    $(this).parents('.accordionButton').trigger('click');
			}

		});
	}

});





// https://gist.github.com/nathansearles/271870d4100f0f045c5c
// isAutoplaySupported(callback);
// Test if HTML5 video autoplay is supported
isAutoplaySupported = function(callback) {
  // Is the callback a function?
  if (typeof callback !== 'function') {
    console.log('isAutoplaySupported: Callback must be a function!');
    return false;
  }
  // Check if sessionStorage exist for autoplaySupported,
  // if so we don't need to check for support again
  if (!sessionStorage.autoplaySupported) {
    // Create video element to test autoplay
    var video = document.createElement('video');
    video.autoplay = true;
    video.src = 'data:video/mp4;base64,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';
    video.load();
    video.style.display = 'none';
    video.playing = false;
    video.play();
    // Check if video plays
    video.onplay = function() {
      this.playing = true;
    };
    // Video has loaded, check autoplay support
    video.oncanplay = function() {
      if (video.playing) {
        sessionStorage.autoplaySupported = 'true';
        callback(true);
      } else {
        sessionStorage.autoplaySupported = 'false';
        callback(false);
      }
    };
  } else {
    // We've already tested for support
    // use sessionStorage.autoplaySupported
    if (sessionStorage.autoplaySupported === 'true') {
      callback(true);
    } else {
      callback(false);
    }
  }
}

// Usage: isAutoplaySupported(callback);
// Using a callback assures that support
// has been properly checked
isAutoplaySupported(function(supported) {
  if (supported) {
    // HTML5 Video Autoplay Supported!
    console.log('HTML5 Video Autoplay Supported!');
  } else {
    // HTML5 Video Autoplay Not Supported :(
    console.log('HTML5 Video Autoplay Not Supported :(');
  }
});


// pop-up 12-18 ticket 6311
// $.fancybox("#hidden");


$(document).ready(function () {

	 var visited = $.cookie('visited');

	  if (visited !== 'yes') {

        // set cookie
        $.cookie('visited', 'yes', { expires: 1 });

        // fancybox code

		setTimeout(function () {

			$(".global-pop").fancybox({
				maxHeight: 1000,
				width: '100%',
				maxWidth: 800,
				fitToView: false,
				autoSize: false,
				scrolling: 'no',
				height: 'auto',
				helpers: { overlay: { closeClick: false } },
				padding: 0,
				afterClose: function () {
					$(".newsletter-pop").removeAttr('id');
				},
				afterLoad: function () {
					$(".fancybox-overlay").addClass("newsletter-pop");
				}
			}).trigger('click');

			$(".fancybox-overlay").addClass("newsletter-pop");
			$("body").addClass("has-news-letter-pop-up");

		},2000)

    }
});
